import { createRouter, createWebHistory } from 'vue-router'

/**
 * Internal dependencies
 */
import routes from './routes'
import store from '@/store'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        const isAuthenticated = localStorage.getItem('authenticated');

        if(store.getters.profile) {
            next()
        } else {
            store.dispatch('loadProfile')
            .then(function(data) {
                next();
            })
            .catch(function(error) {
                if(error.response) {
                    const status = error.response.status;

                    if(status == 401) {
                        router.push('/login');
                    }
                }
            })
        }
    } else {
        next() // make sure to always call next()!
    }
  })
  

export default router
